import { useState } from 'react';

import { Pencil, Check } from 'lucide-react';

import { useSaleTotalsEditor } from '../../../../hooks/sale/useSaleTotalsEditor';

import { formatCurrency } from '../../../../utils/formatCurrency';

interface Props {
  item: any;
}

const POSSummaryTotalRow: React.FC<Props> = ({ item }) => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { updateTotalField } = useSaleTotalsEditor();

  // =====================================================
  // 🔹 State
  // =====================================================
  const [editing, setEditing] = useState(false);

  const [value, setValue] = useState(
    item.value != null ? String(item.value) : ''
  );

  // =====================================================
  // 🔹 Actions
  // =====================================================
  const handleConfirm = async () => {
    const numericValue = value === '' ? 0 : Number(value);

    await updateTotalField(item.key, numericValue, item.recalculates);

    setEditing(false);
  };

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className="
      flex
      items-center
      justify-between

      gap-3
    "
    >
      {/* ===================================================== */}
      {/* 🔹 Label */}
      {/* ===================================================== */}
      <span
        className="
        text-sm
        font-medium

        text-body
      "
      >
        {item.label}
      </span>

      {/* ===================================================== */}
      {/* 🔹 Value */}
      {/* ===================================================== */}
      {!editing ? (
        <div className="flex items-center gap-2">
          {/* 🔹 Amount */}
          <span
            className="
            text-sm
            font-semibold

            text-primary
          "
          >
            ${formatCurrency(item.value)}
          </span>

          {/* 🔹 Edit */}
          {item.editable && (
            <button
              onClick={() => setEditing(true)}
              className="
              flex
              h-7
              w-7
              items-center
              justify-center

              rounded-lg

              text-body

              transition-all
              duration-200

              hover:bg-primary/10
              hover:text-primary
            "
            >
              <Pencil size={14} />
            </button>
          )}
        </div>
      ) : (
        <div className="flex items-center gap-2">
          {/* 🔹 Input */}
          <input
            type="number"
            min={0}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="
            w-24

            rounded-lg
            border
            border-stroke

            bg-whiten

            px-3
            py-1.5

            text-right
            text-sm
            font-medium

            text-black

            outline-none

            transition-all
            duration-200

            focus:border-primary
            focus:ring-2
            focus:ring-primary/20

            dark:border-strokedark
            dark:bg-boxdark
            dark:text-white
          "
          />

          {/* 🔹 Confirm */}
          <button
            onClick={handleConfirm}
            className="
            flex
            h-8
            w-8
            items-center
            justify-center

            rounded-lg

            bg-success
            text-white

            transition-all
            duration-200

            hover:opacity-90
          "
          >
            <Check size={15} />
          </button>
        </div>
      )}
    </div>
  );
};

export default POSSummaryTotalRow;
